import { useState, useEffect } from "react";

type size = "large" | "medium" | "small";
// Hook, credits: https://usehooks.com/useWindowSize/

function getScreenSize(): size {
  if (!isClient) {
    return "large";
  } else {
    if (window.innerWidth < 600) {
      return "small";
    } else if (window.innerWidth < 900) {
      return "medium";
    } else {
      return "large";
    }
  }
}

const isClient = typeof window === "object";

export function useScreenSize() {
  const [size, setSize] = useState(getScreenSize());

  useEffect(() => {
    if (!isClient) {
      return;
    }

    function handleResize() {
      setSize(getScreenSize());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return size;
}
